/* eslint-disable @typescript-eslint/no-misused-promises */
/**
 * Save Phone Number form
 */

import {
  Button,
  Flex,
  Heading,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useUpdateMobileNumberQuery } from "_actions/AuthActions";
import { SuccessToastHandler } from "components/helpers/ToastHelpers";
import { useGetUserProfileQuery } from "queries";
import { useForm } from "react-hook-form";

import { SavePhNumberSchema } from "../../config/schema/SavePhNumber";
import { ModalTypes } from "../../config/types/modals";
import { SecondaryButton } from "../base/atoms/HJSButton";
import { useEffect } from "react";
import { setFormErrors } from "utils";
// import PhoneInputWithCountrySelect from "react-phone-number-input";

interface IPhoneNumber {
  phoneNumber: string;
}

const initialFormValues: IPhoneNumber = {
  phoneNumber: "",
};
interface IModalComponentProps {
  changeModalType: (modalType: ModalTypes) => void;
  onClose: () => void;
}
type TModalComponent = (props: IModalComponentProps) => JSX.Element;

const SavePhNumber: TModalComponent = ({
  changeModalType,
  onClose,
}: IModalComponentProps) => {
  const {
    control,
    setValue,
    watch,
    // useWatch,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    register,
    trigger,
  } = useForm({
    resolver: yupResolver(SavePhNumberSchema),
    defaultValues: initialFormValues,
  });

  // const phoneNumber = useWatch({
  //   control,
  //   name: "phoneNumber",
  // });

  const toast = useToast();

  // const [isLoading, setIsLoading] = useState();
  const { data: userDetails } = useGetUserProfileQuery();

  const { mutate: updateMobileNumberQuery, isLoading } =
    useUpdateMobileNumberQuery();

  const onSubmit = async (data: any): Promise<any> => {
    updateMobileNumberQuery(
      {
        phoneNumber: data?.phoneNumber,
        name: userDetails?.name,
      },
      {
        onSuccess: () => {
          SuccessToastHandler({
            toast,
            title: "Success! 🎉",
            description: "Mobile number saved successfully",
          });
          changeModalType(ModalTypes.USER_PROFILE);
          onClose();
        },
        onError: (error) => {
          setFormErrors(error, setError);
        },
      }
    );
  };

  useEffect(() => {
    if (userDetails?.phone as boolean)
      setValue("phoneNumber", userDetails?.phone);
  }, [userDetails]);

  return (
    <ModalContent px={{ base: 0, md: 6 }} py={4}>
      <ModalHeader>
        <VStack align="flex-start">
          <Heading as="h2" fontSize={[20, 20, 30, 40]} color="teal.900">
            {(userDetails?.phone as boolean) ? "Update" : "Save"} Mobile Number
          </Heading>
          {!(userDetails?.phone as boolean) && (
            <Text color="hjsBlack" fontWeight="500" fontSize={[14, 14, 15, 16]}>
              Please save your mobile number here to opt into SMS surveys.
            </Text>
          )}
        </VStack>
      </ModalHeader>
      <ModalCloseButton />
      <form onSubmit={handleSubmit(onSubmit, (e) => console.log("error", e))}>
        <ModalBody>
          <VStack my={10} alignItems="flex-start">
            <Flex border="2px solid #00000033" borderRadius={10} width="full">
              <Flex
                color="hjsBlack"
                border="none"
                bgColor="hjsPrimaryLight"
                alignItems="center"
                px={4}
                borderTopLeftRadius="inherit"
                borderBottomLeftRadius="inherit"
              >
                +1
              </Flex>
              <input
                placeholder="Enter your mobile number"
                type="tel"
                value={watch("phoneNumber")}
                {...register("phoneNumber")}
                className="border-none outline-none p-2 rounded-[10px] w-full"
              />
            </Flex>

            {errors?.phoneNumber?.message !== undefined && (
              <Text color="red.600" pl={1.5}>
                {errors?.phoneNumber?.message}
              </Text>
            )}
          </VStack>
        </ModalBody>
        <ModalFooter mb={6} alignItems="center" justifyContent="center">
          <VStack>
            <SecondaryButton
              my={4}
              type="submit"
              px={16}
              isLoading={isLoading}
              fontSize={[14, 14, 16]}
            >
              {(userDetails?.phone as boolean) ? "Update" : "Save"} my number
            </SecondaryButton>
            <Button
              fontWeight="400"
              color="hjsBlack"
              variant="link"
              onClick={() => changeModalType(ModalTypes.USER_PROFILE)}
              fontSize={[14, 14, 16]}
            >
              Go Back
            </Button>
          </VStack>
        </ModalFooter>
      </form>
    </ModalContent>
  );
};

export default SavePhNumber;
